import {UIDHeaderController} from '../../ui_html/header/UIDHeaderController'
import {UIWHeaderController} from '../../ui_html/header/UIWHeaderController'
import {UIDFooterController} from '../../ui_html/UIDFooterController'
import {UIWFooterController} from '../../ui_html/UIWFooterController'
import {UIWProfileController} from '../../profile/UIWProfileController'
import {ClientUserState} from '../../../../shared/scripts/ClientUserState'

export class UIDProfileSceneController {
    private readonly headerController: UIWHeaderController
    private readonly footerController: UIWFooterController
    profileController: UIWProfileController
    private readonly profileSceneContainerDiv: HTMLDivElement

    constructor(headerController: UIWHeaderController, footerController: UIWFooterController) {
        this.headerController = headerController
        this.footerController = footerController
        this.profileController = new UIWProfileController()
        this.profileSceneContainerDiv = document.getElementById('scene_discord_profile_container') as HTMLDivElement
    }

    hide() {
        this.profileSceneContainerDiv.classList.add('hidden')
    }

    show() {
        this.profileSceneContainerDiv.classList.remove('hidden')

        if(this.headerController instanceof UIDHeaderController) this.headerController.deactivateAllButtons()
        if(this.footerController instanceof UIDFooterController) this.footerController.deactivateAllButtons()
    }

    async updatePageContent(username: string) {
        const profileController = this.profileController

        profileController.setUsername(username)
        profileController.profileLinkController.resetApiCalls()
        profileController.profileLinkController.showSection(0)
        await profileController.getStickyPlayerInfo()
        profileController.friendsController.setUsername(username)

        const userIsMe = ClientUserState.userState?.username === username
        profileController.friendsController.profileIsCurrentUser = userIsMe
        await profileController.friendsController.createDropdown()

        if(userIsMe) {
            profileController.settingsController.showSettingsTab()
            profileController.friendsController.showFriendsTab()
        } else {
            profileController.friendsController.hideFriendsTab()
            profileController.settingsController.hideSettingsTab()
        }

        await profileController.makeApiCall()
    }
}
